import { useMemo, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

const dashboardData = {
  All: {
    kpis: {
      headcount: 120,
      attrition: "8%",
      salary: "€55K",
    },
    trend: [
      { month: "Jan", employees: 100 },
      { month: "Feb", employees: 110 },
      { month: "Mar", employees: 120 },
      { month: "Apr", employees: 115 },
    ],
  },
  HR: {
    kpis: {
      headcount: 28,
      attrition: "6%",
      salary: "€48K",
    },
    trend: [
      { month: "Jan", employees: 20 },
      { month: "Feb", employees: 24 },
      { month: "Mar", employees: 30 },
      { month: "Apr", employees: 28 },
    ],
  },
  IT: {
    kpis: {
      headcount: 58,
      attrition: "10%",
      salary: "€68K",
    },
    trend: [
      { month: "Jan", employees: 50 },
      { month: "Feb", employees: 54 },
      { month: "Mar", employees: 60 },
      { month: "Apr", employees: 58 },
    ],
  },
  Finance: {
    kpis: {
      headcount: 34,
      attrition: "5%",
      salary: "€60K",
    },
    trend: [
      { month: "Jan", employees: 30 },
      { month: "Feb", employees: 31 },
      { month: "Mar", employees: 33 },
      { month: "Apr", employees: 34 },
    ],
  },
};

function App() {
  const [department, setDepartment] = useState("All");

  const selectedData = useMemo(() => {
    return dashboardData[department];
  }, [department]);

  const cardStyle = {
    backgroundColor: "#1e293b",
    padding: "20px",
    borderRadius: "14px",
    width: "220px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.18)",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#0f172a",
        color: "white",
        fontFamily: "Arial, sans-serif",
        padding: "32px",
      }}
    >
      <div style={{ marginBottom: "24px" }}>
        <h1 style={{ margin: 0, fontSize: "48px" }}>HRIS Dashboard</h1>
        <p style={{ marginTop: "10px", color: "#cbd5e1" }}>
          Department-level HR analytics overview
        </p>
      </div>

      <div style={{ marginBottom: "24px" }}>
        <label
          htmlFor="department"
          style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}
        >
          Filter by Department
        </label>
        <select
          id="department"
          value={department}
          onChange={(e) => setDepartment(e.target.value)}
          style={{
            padding: "10px 12px",
            borderRadius: "8px",
            border: "none",
            fontSize: "16px",
            minWidth: "220px",
          }}
        >
          <option value="All">All Departments</option>
          <option value="HR">HR</option>
          <option value="IT">IT</option>
          <option value="Finance">Finance</option>
        </select>
      </div>

      <div
        style={{
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          marginBottom: "32px",
        }}
      >
        <div style={cardStyle}>
          <h3 style={{ marginTop: 0, color: "#cbd5e1" }}>Headcount</h3>
          <p style={{ fontSize: "36px", fontWeight: "bold", marginBottom: 0 }}>
            {selectedData.kpis.headcount}
          </p>
        </div>

        <div style={cardStyle}>
          <h3 style={{ marginTop: 0, color: "#cbd5e1" }}>Attrition</h3>
          <p style={{ fontSize: "36px", fontWeight: "bold", marginBottom: 0 }}>
            {selectedData.kpis.attrition}
          </p>
        </div>

        <div style={cardStyle}>
          <h3 style={{ marginTop: 0, color: "#cbd5e1" }}>Average Salary</h3>
          <p style={{ fontSize: "36px", fontWeight: "bold", marginBottom: 0 }}>
            {selectedData.kpis.salary}
          </p>
        </div>
      </div>

      <div
        style={{
          backgroundColor: "white",
          color: "black",
          borderRadius: "16px",
          padding: "24px",
          width: "100%",
          maxWidth: "760px",
          boxShadow: "0 10px 24px rgba(0,0,0,0.2)",
        }}
      >
        <h2 style={{ marginTop: 0 }}>
          Headcount Trend {department !== "All" ? `- ${department}` : ""}
        </h2>

        <div style={{ width: "100%", height: 320 }}>
          <ResponsiveContainer>
            <BarChart data={selectedData.trend}>
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="employees" fill="#2563eb" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default App;